module.exports = __webpack_public_path__ + "97b1b81efca153e2270d7a67de81cf86.png";